import { createStyles, rem } from '@mantine/core'

import { hexToRgb, hsbToRgb, rgbToHsb } from 'utils/colors'

// import { hexToHSL, hslToHex } from 'utils/colors'

export interface StylesParams {
  bgColor: string
}
export default createStyles((theme, params: StylesParams) => {
  const { bgColor: bgColorInit = '#fc7419' } = params
  const timer = 0.6
  const borderWidth = 1
  const borderColorDark = bgColorInit
  const borderColorLight = 'transparent'
  const rgb: any = hexToRgb(bgColorInit, true)
  const hsb = rgbToHsb(rgb.r, rgb.g, rgb.b)
  const newRgb = hsbToRgb(hsb[0], 9, 99)
  const bgColor = `rgb(${newRgb[0]},${newRgb[1]},${newRgb[2]})`
  const newRgbBorder = hsbToRgb(hsb[0], 24, 98)
  const borderColor = `rgb(${newRgbBorder[0]},${newRgbBorder[1]},${newRgbBorder[2]})`
  return {
    root: {
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: bgColor,
      borderRadius: rem(16),
      transition: 'all .3s ease',
      [theme.fn.smallerThan('sm')]: {
        border: `1px solid ${borderColor}`,
      },
      '&:hover': {
        [theme.fn.largerThan('sm')]: {
          backgroundColor: borderColor,
          transform: 'translateY(-10px)',
        },
      },
    },
    wrapper: {
      position: 'relative',
      padding: rem(borderWidth),
      borderRadius: 'inherit',
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        zIndex: 1,
        width: rem(10),
        height: 0,
        backgroundColor: bgColor,
        transitionProperty: 'all',
        transitionDuration: `${timer}s`,
      },
      '&:before': {
        top: '-100%',
        left: 0,
        backgroundImage: `linear-gradient(${borderColorDark} ,${borderColorDark} ,${borderColorDark} ,${borderColorDark} ,${borderColorDark} ,${borderColorDark} , ${borderColorLight})`,
      },
      '&:after': {
        bottom: '-100%',
        right: 0,
        backgroundImage: `linear-gradient(${borderColorLight}, ${borderColorDark},${borderColorDark} ,${borderColorDark} ,${borderColorDark} ,${borderColorDark} , ${borderColorDark})`,
      },
    },
    inner: {
      position: 'relative',
      zIndex: 2,
      display: 'flex',
      alignItems: 'center',
      gap: rem(16),
      padding: rem(16),
      justifyContent: 'space-between',
      // backgroundColor: theme.fn.lighten(bgColor, 0.85),
      borderRadius: 'inherit',
      [theme.fn.largerThan('sm')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'center',
        minHeight: rem(102),
      },
    },
    infoWrapper: {
      display: 'flex',
      gap: rem(16),
      alignItems: 'center',
      [theme.fn.largerThan('sm')]: {
        justifyContent: 'space-between',
      },
    },
    thumbnail: {
      transition: 'all .3s ease',
      [theme.fn.largerThan('sm')]: {
        order: 2,
      },
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(4),
      [theme.fn.largerThan('sm')]: {
        order: 1,
      },
    },
    title: {},
    exploreLink: {
      display: 'flex',
      alignItems: 'center',
      gap: rem(1),
    },
    exploreText: {
      lineHeight: rem(18),
    },
    exploreArrow: {
      color: theme.colors.gray[4],
      transition: 'transform .3s ease',
      fontSize: 0,
    },
    arrow: {
      background: '#fff',
      borderRadius: '50%',
      width: rem(24),
      height: rem(24),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }
})
